import leads from './steps/leads'
import products from './steps/products'
import plans from './steps/plans'
import payment from './steps/payment'
import remarketing from './remarketing'
import whatsappLink from './whatsappLink'
import upsell from './upsell'
import prospect from './prospect'

export default {
  leads,
  products,
  plans,
  payment,
  remarketing,
  whatsappLink,
  upsell,
  prospect
}
